import React, { useEffect } from "react";
import HeroAbout from "../sections/HeroAbout";

const HomePage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return <HeroAbout />;
};

export default HomePage;
